import { render } from "./Fr.vue?vue&type=template&id=5fc5222f"
import script from "./Fr.vue?vue&type=script&lang=js"
export * from "./Fr.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-archive/__GITLAB/archive-collections/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__